import * as React from 'react';
import PropTypes from 'prop-types';

const SvgNavigationMapHeatSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <clipPath id="navigation_map_heat_small_svg__a">
        <path d="M0 0h24v24H0z" />
      </clipPath>
      <g clipPath="url(#navigation_map_heat_small_svg__a)" fill="">
        <path d="M15.97 12.78a4.693 4.693 0 00-.95-1.14V3.32a3.025 3.025 0 00-6.05 0v8.32c-.366.325-.68.704-.93 1.125L-.01 17.03 12 23.38l12.01-6.35zm-5.65-.48V3.32a1.675 1.675 0 013.35 0v8.97a3.292 3.292 0 011.57 2.78 3.24 3.24 0 11-4.92-2.77zm-7.44 4.73l4.56-2.42a3.53 3.53 0 00-.03.46 4.59 4.59 0 109.18 0c0-.147-.01-.294-.03-.44l4.56 2.4L12 21.85z" />
        <path d="M12 17.21a2.143 2.143 0 00.67-4.18v-9.7h-1.34v9.7a2.145 2.145 0 00.67 4.18z" />
      </g>
    </svg>
  )
);
SvgNavigationMapHeatSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgNavigationMapHeatSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgNavigationMapHeatSmall;
